var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleMode}},[(_vm.currentMode === 'list')?_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-view-grid")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-view-list")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }